module.exports = __webpack_public_path__ + "static/media/Ana-s-game-of.0159c034.png";